module.exports = __webpack_public_path__ + "img/3.5e700ca3.png";